<template>
    <el-drawer
        :title="drawerTitle"
        :visible.sync="visible"
        size="960px"
        append-to-body
        :wrapperClosable="false"
        @closed="OnClosed">
        <div class="weekly-report-drawer" v-loading="loading">
            <el-alert
                type="info"
                :closable="false"
                show-icon
                :title="IsOwner ? '确认无误后可复制正文，粘贴到企业微信「文档-汇报」中提交。' : '当前为查看他人周报，仅本人可修改或确认。'"
                style="margin-bottom: 12px;">
            </el-alert>

            <div class="meta-row" v-if="form.id">
                <el-tag v-if="!form.confirmed_at" type="warning" size="small">待确认</el-tag>
                <el-tag v-else type="success" size="small">已确认</el-tag>
                <span class="meta-text">{{ form.users?.name ? form.users.name + ' · ' : '' }}周期：{{ FormatWeek(form.work_start) }} ~ {{ FormatWeek(form.work_end) }}</span>
            </div>

            <div class="section-title">周报正文</div>
            <el-input
                type="textarea"
                v-model="editContent"
                :rows="16"
                :readonly="!CanEdit"
                placeholder="暂无周报内容">
            </el-input>

            <div class="section-title" v-if="HasSourceItems">本周工作条目（系统提取）</div>
            <div class="source-list" v-if="HasSourceItems">
                <div class="source-project" v-for="(project, pIdx) in (form.source_items.projects || [])" :key="'p-' + pIdx">
                    <div class="source-project-title">
                        {{ project.project_name || '未知项目' }}
                        <span v-if="project.project_number" class="muted">（{{ project.project_number }}）</span>
                    </div>
                    <ul>
                        <li v-for="(wo, wIdx) in (project.wos || [])" :key="'w-' + wIdx">
                            <el-tag size="mini" type="info">工单</el-tag>
                            {{ wo.name }}
                            <span v-if="wo.number" class="muted">（{{ wo.number }}）</span>
                        </li>
                    </ul>
                </div>
                <div class="source-project" v-if="form.source_items.unbound_wos && form.source_items.unbound_wos.length">
                    <div class="source-project-title">未关联项目</div>
                    <ul>
                        <li v-for="(wo, wIdx) in form.source_items.unbound_wos" :key="'u-' + wIdx">
                            <el-tag size="mini" type="warning">工单</el-tag>
                            {{ wo.name }}
                            <span v-if="wo.number" class="muted">（{{ wo.number }}）</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="drawer-actions">
                <el-button @click="CopyContent" :disabled="!editContent">复制周报</el-button>
                <el-button v-if="CanEdit" @click="SaveContent" :loading="saving">保存修改</el-button>
                <el-button v-if="CanEdit" type="primary" @click="ConfirmReport" :loading="saving">确认周报</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data () {
        return {
            visible: false,
            loading: false,
            saving: false,
            editContent: '',
            form: this.EmptyForm()
        }
    },
    computed: {
        drawerTitle () {
            if (!this.form.id) return '周报详情'
            const name = this.form.users?.name ? this.form.users.name + ' · ' : ''
            return '周报详情 · ' + name + this.FormatWeek(this.form.work_start) + ' ~ ' + this.FormatWeek(this.form.work_end)
        },
        IsOwner () {
            return Number(this.form.users_id) === Number(this.$store.state.user.id)
        },
        CanEdit () {
            return this.IsOwner && !this.form.confirmed_at
        },
        HasSourceItems () {
            const items = this.form.source_items || {}
            return (items.projects && items.projects.length) || (items.unbound_wos && items.unbound_wos.length)
        }
    },
    methods: {
        EmptyForm () {
            return {
                id: null,
                users_id: null,
                content_ai: '',
                content_confirmed: '',
                confirmed_at: null,
                work_start: '',
                work_end: '',
                users: null,
                source_items: {
                    projects: [],
                    unbound_wos: []
                }
            }
        },
        Open (id) {
            this.visible = true
            this.loading = true
            this.$http.post('/9api/my/weekly-report/search-first', {
                id: id,
                append: ['users', 'status', 'status_text', 'content_display']
            }).then(res => {
                this.form = Object.assign(this.EmptyForm(), res.data)
                this.editContent = res.data.content_confirmed || res.data.content_ai || ''
            }).finally(() => {
                this.loading = false
            })
        },
        OnClosed () {
            this.form = this.EmptyForm()
            this.editContent = ''
            this.$emit('closed')
        },
        FormatWeek (value) {
            if (!value) return ''
            return String(value).substring(0, 10)
        },
        SaveContent () {
            if (!this.CanEdit) {
                this.$message.warning('仅本人可修改周报')
                return
            }
            if (!this.editContent || !this.editContent.trim()) {
                this.$message.warning('周报内容不能为空')
                return
            }
            this.saving = true
            this.$http.post('/9api/my/weekly-report/update', {
                id: this.form.id,
                content_confirmed: this.editContent
            }).then(res => {
                this.form = Object.assign(this.EmptyForm(), res.data)
                this.$message.success('已保存')
                this.$emit('onChange')
            }).finally(() => {
                this.saving = false
            })
        },
        ConfirmReport () {
            if (!this.CanEdit) {
                this.$message.warning('仅本人可确认周报')
                return
            }
            if (!this.editContent || !this.editContent.trim()) {
                this.$message.warning('周报内容不能为空')
                return
            }
            this.$confirm('确认后表示本周周报内容无误，可复制到企业微信「文档-汇报」提交。是否确认？', '确认周报', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.saving = true
                return this.$http.post('/9api/my/weekly-report/confirm', {
                    id: this.form.id,
                    content_confirmed: this.editContent
                })
            }).then(res => {
                if (!res) return
                this.form = Object.assign(this.EmptyForm(), res.data)
                this.editContent = res.data.content_confirmed || this.editContent
                this.$message.success('周报已确认')
                this.$emit('onChange')
            }).catch(() => {}).finally(() => {
                this.saving = false
            })
        },
        CopyContent () {
            const text = this.editContent || ''
            if (!text) return

            const done = () => this.$message.success('已复制，请粘贴到企业微信「文档-汇报」')

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(done).catch(() => this.FallbackCopy(text, done))
                return
            }
            this.FallbackCopy(text, done)
        },
        FallbackCopy (text, done) {
            const textarea = document.createElement('textarea')
            textarea.value = text
            textarea.setAttribute('readonly', 'readonly')
            textarea.style.position = 'fixed'
            textarea.style.left = '-9999px'
            document.body.appendChild(textarea)
            textarea.select()
            try {
                document.execCommand('copy')
                done()
            } catch (e) {
                this.$message.error('复制失败，请手动选择文本复制')
            }
            document.body.removeChild(textarea)
        }
    }
}
</script>

<style lang="less" scoped>
.weekly-report-drawer {
    padding: 0 20px 24px;
}
.meta-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
}
.meta-text {
    color: #606266;
    font-size: 13px;
}
.section-title {
    margin: 14px 0 8px;
    font-weight: 600;
    color: #303133;
}
.source-list {
    max-height: 220px;
    overflow: auto;
    color: #606266;
    font-size: 13px;
}
.source-project {
    margin-bottom: 12px;
    &:last-child {
        margin-bottom: 0;
    }
}
.source-project-title {
    font-weight: 600;
    color: #303133;
    margin-bottom: 6px;
}
.source-project ul {
    margin: 0;
    padding-left: 18px;
    li {
        margin-bottom: 4px;
    }
}
.muted {
    color: #909399;
}
.drawer-actions {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}
</style>
